import { FC } from 'react';

import { useBreakpoint } from '@hh.ru/magritte-ui';

import Badge, { BadgeAppearance } from 'bloko/blocks/badge';
import Button, { ButtonAppearance, ButtonIconPosition } from 'bloko/blocks/button';
import Icon, { IconKind, IconScale, IconView } from 'bloko/blocks/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import LeadsModal from 'components/Dashboard/LeadsModal/LeadsModal';

import { selectLeadsCount } from 'store/autoReducers';
import { useSelector } from 'store/utils';

import styles from 'components/Dashboard/LeadsButton/LeadsButton.module.less';

const LeadsButton: FC = () => {
    const trl = useTrls();
    const { isMobile } = useBreakpoint();
    const leads = useSelector(selectLeadsCount);
    const [visible, setVisibleOn, setVisibleOff] = useOnOffState(false);

    return (
        <>
            <Button
                appearance={ButtonAppearance.Filled}
                icon={<Icon view={IconView.Envelope} kind={IconKind.Opened} scale={IconScale.Small} />}
                onClick={setVisibleOn}
                iconPosition={!isMobile || leads ? ButtonIconPosition.Left : undefined}
            >
                {!isMobile && <span className={styles.leadsbuttonContent}>{trl('dashboard.title.leads')}</span>}
                <Badge value={Math.min(100, leads)} appearance={BadgeAppearance.Warning} hidden={!leads} />
            </Button>
            <LeadsModal visible={visible} onClose={setVisibleOff} />
        </>
    );
};

export default withErrorBoundary(LeadsButton);
